/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import styled from 'styled-components';

// Styled components matching original PreLikeText styling
const HelpPanelContainer = styled.div`
    position: sticky;
    top: 0;
    padding: 15px;
`;

const HelpTitle = styled.h6`
    font-weight: 600;
    margin-bottom: 1rem;
`;

const PreLikeText = styled.div`
    margin-top: 5px;
    display: block;
    white-space: pre-wrap;
    unicode-bidi: embed;
    font-family: monospace;
    color: #212529;
    font-size: 87.5%;
`;

const HelpTable = styled(Table)`
    margin-bottom: 0;
    min-width: 100%;
`;

const HelpPanel = ({ title = "Help", data = [], className, style, height = '200vh' }) => {
    return (
        <div style={{ height }}>
            <HelpPanelContainer className={className} style={style}>
                <HelpTitle>{title}</HelpTitle>
                <PreLikeText>
                    <HelpTable size="sm">
                        <thead>
                            <tr>
                                <th>Property</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ padding: '5px' }}>{item.property}</td>
                                    <td style={{ padding: '5px' }}>{item.description}</td>
                                </tr>
                            ))}
                        </tbody>
                    </HelpTable>
                </PreLikeText>
            </HelpPanelContainer>
        </div>
    );
};

HelpPanel.propTypes = {
    title: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({
        property: PropTypes.string.isRequired,
        description: PropTypes.node.isRequired, // Changed from string to node to accept JSX
    })).isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    height: PropTypes.string,
};

export default HelpPanel;
